module.exports = require("@babel/runtime/regenerator");


//////////////////
// WEBPACK FOOTER
// external "@babel/runtime/regenerator"
// module id = @babel/runtime/regenerator
// module chunks = 0 3